import { render, staticRenderFns } from "./PackageLimitAlertConfigDialog.vue?vue&type=template&id=9fef3ab6"
import script from "./PackageLimitAlertConfigDialog.vue?vue&type=script&lang=js"
export * from "./PackageLimitAlertConfigDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9fef3ab6')) {
      api.createRecord('9fef3ab6', component.options)
    } else {
      api.reload('9fef3ab6', component.options)
    }
    module.hot.accept("./PackageLimitAlertConfigDialog.vue?vue&type=template&id=9fef3ab6", function () {
      api.rerender('9fef3ab6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/package_student/components/dialog/PackageLimitAlertConfigDialog.vue"
export default component.exports